/* eslint-disable no-console */

try {
  if (navigator.serviceWorker) {
    navigator.serviceWorker.register('/service-worker.js', { scope: '/' }).then(function(worker){
      var interv = setInterval(function(){
        if(window.update){
          worker.active.postMessage(window.update.toString());
        }
        window.clearInterval(interv)
      }, 700);
    }).catch(function(err) {
      console.warn('SW registration skipped:', err);
    });
  }
} catch(e) {
  console.warn('SW not available:', e);
}
